import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { PrismicLink } from '@prismicio/react'
import { useMergePrismicPreviewData } from 'gatsby-plugin-prismic-previews'

// Components
import Social from './social'

// SVGs
import ChevronRight from './svg/chevronRight'

let newDate = new Date()
let year = newDate.getFullYear()

const Footer = () => {
  const staticData = useStaticQuery(graphql`
    {
      prismicNavigation {
        ...PrismicNavigationFragment
      }
      prismicSocial {
        ...PrismicSocialFragment
      }
      prismicConfig {
        ...PrismicConfigFragment
      }
    }
  `)
  const data = useMergePrismicPreviewData(staticData)
  const footerData = data.prismicNavigation.data
  const socialData = data.prismicSocial.data
  const configData = data.prismicConfig.data
  return (
    <footer role='banner' className='mt-auto'>
      <div className='mt-10 bg-blue-900'>
        <div className='mx-auto max-w-screen-xl px-4 py-8'>
          <div className='grid-cols-4 gap-8 space-y-8 md:grid md:space-y-0'>
            {footerData.body.map((footer, index) => {
              return (
                <div key={`footer-${index}`}>
                  <div className='text-sm font-semibold uppercase tracking-wider text-gray-200'>{footer.primary.title}</div>
                  <ul className='mt-4 space-y-4'>
                    {footer.items.map((footerItem, index) => {
                      return (
                        <li className='flex items-center' key={`footerItem-${index}`}>
                          <ChevronRight className='h-4 w-4 text-orange-500 mr-1'/>
                          <PrismicLink className='block transform font-medium text-white ring-orange-400 transition duration-150 ease-linear hover:text-orange-500' href={footerItem.link.url}>
                            {footerItem.link_label}
                          </PrismicLink>
                        </li>
                      )
                    })}
                  </ul>
                </div>
              )
            })}
            <div className='col-span-2 mt-8 space-y-4 text-white lg:col-span-1 lg:mt-0'>
              <div className='text-sm font-semibold uppercase tracking-wider text-gray-200'>{configData.title || 'Subscribe to our newsletter'}</div>
              <p className='text-base'>{configData.text || 'The latest news, articles, and resources, sent to your inbox.'}</p>
              <div className='sm:flex sm:max-w-md'>
                <div className='mt-3 rounded-md sm:mt-0 sm:flex-shrink-0'>
                  <a href='/sign-up-to-our-mailing-list/' className='button button-brand flex justify-center'>
                    {configData.button_text || 'subscribe'}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='bg-gray-900'>
        <div className='mx-auto max-w-screen-xl flex-row justify-between px-4 text-base font-light text-white md:flex'>
          <div className='py-3 text-center md:text-left'>
            Copyright &copy; {year} - {configData.company_display_name}
          </div>
          <div className='flex justify-center py-3'>
            <Social networks={socialData} />
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
